import { compose } from '@reduxjs/toolkit';
import { fetchAllProductsReducer } from './fetchAllProducts';

export const extraReducers = compose(fetchAllProductsReducer);
export { fetchAllProducts } from './fetchAllProducts';
